import { render } from "./oqcForm.vue?vue&type=template&id=14528305&scoped=true"
import script from "./oqcForm.vue?vue&type=script&lang=js"
export * from "./oqcForm.vue?vue&type=script&lang=js"

import "./oqcForm.vue?vue&type=style&index=0&id=14528305&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14528305"]])

export default __exports__